import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=02108f44&scoped=true"
import script from "./LogsTable.vue?vue&type=script&lang=js"
export * from "./LogsTable.vue?vue&type=script&lang=js"
import style0 from "./LogsTable.vue?vue&type=style&index=0&id=02108f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02108f44",
  null
  
)

export default component.exports